import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from "@angular/material/dialog";
import { Observable, lastValueFrom } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CrudInventoryComponent } from "./crud-inventory/crud-inventory.component";
import { BulkContainerInventoryComponent } from "./bulk-container-inventory/bulk-container-inventory.component";
import { BulkVirtualContainerInventoryComponent } from "./bulk-virtual-container-inventory/bulk-virtual-container-inventory.component";
import { ConfigService } from "../../services/config.service";
import { PrincipalinventoryService } from "../../services/principalinventory.service";
import { ManuracturerService } from "../../services/manuracturer.service";
import { PurchaseService } from "../../services/purchase.service";
import { Router, ActivatedRoute } from "@angular/router";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { Title } from "@angular/platform-browser";
import { UserService } from "../../services/user.service";
import { LocationService } from "../../services/location.service";
import { SecurazeService } from "../../services/securaze.service";
import { TicketsService } from "../../services/tickets.service";
import { TitleService } from '../../services/title.service';
import { LoadingComponent } from "../../shared/components/loading/loading.component";
import { MobilesdevicesService } from "../../services/mobilesdevices.service";
import { GuiGuard } from '../../shared/guard/base-gui-guard';
/*ATTRIBUTE MULTIPLE ITEMS*/
import { attributeMultipleItemsComponent } from "../../shared/components/attribute-multiple-items/attribute-multiple-items.component";

import { Methods } from "../../shared/methods";
import swal from "sweetalert2";

declare var $: any;

export interface PO {
  id: number;
  po: number;
}

@Component({
  selector: "app-inventory",
  templateUrl: "./inventory.component.html",
  styleUrls: ["./inventory.component.css"],
})
export class InventoryComponent implements OnInit, AfterViewInit {
  @ViewChild("childScrollElement") childScrollElement: ElementRef;

  public mtds: Methods = new Methods();
  public type = "ALL";
  public data: DinamicData = new DinamicData([
    "check",
    "Item",
    "Brand",
    "SN",
    "Category",
    "Description",
    "Condition",
    "PO-Line",
    "QTY",
    "Cost",
    "Status",
    "Receive Status",
    "SO - Line",
    "SO Rep",
    "Warehouse",
    "PO Rep",
    "Update Date",
    "Customer Asset Tag",
    "Location",
    "Batch",
    "Container Id",
    "Virtual Container",
    "Testing Status",
    "Added",
    "Date Received",
    "IQ ID",
    "ID",
    "Vendor",
    "Actions",
  ]);
  public mfgrList: Array<any> = [];
  public loadingMFGR = true;
  public statsuList: Array<string> = [
    "Available",
    "Invoiced",
    "NotAvailable",
    "Received",
    "Removed",
    "Reserved",
    "Return in Process",
    "Scrap",
    "Voided",
  ];
  public options: Array<any> = [];
  public loading = false;

  public campoBusqueda = "";
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;

  public filterStatus = "";
  public filterMfgr = "";

  public bulk: Array<number> = [];
  public arrayInventoryReceived: Array<any> = [];

  public identity;
  public apikey;
  public token;

  /*SECCIÓN PARA MOSTRAR INFORMACIÓN AL SELECCIONAR COLUMNA*/
  public showDetails = false;
  public showSpecs = false;
  public showSpecsWorkflow = false;
  public showBothSpecs = false;
  public workflow: string[][];
  public internalComments;
  public systemComments;
  public disabled = true;

  public batteries: string[][];
  public components: string[][];
  public cpus: string[][];
  public hdds: string[][];
  public memories: string[][];
  public networks: string[][];
  public system: string[][];
  public testing: string[][];
  public video: string[][];
  public poline;
  public batchline;
  public mdm;
  public computrace;
  selectedTabIndex: number = 1; // Inicializa a 0 para que la primera pestaña esté activa por defecto
  public tablaDinamicaSet: boolean = false;
  /* bitraser */
  public raserhardware = null;
  public raserbatery = null;
  public raserdisk = null;
  public raservideo = null;
  public raserhardwaretest = null;
  public rasermemory = null;
  public rasernetwork = null;
  public raserprocessor = null;
  public bitrasershow = false
  /* phonecheck */
  public phonecheckinfo = null;
  public phonecheckpart = null;
  public phonecheckshow = false;
  /*MOSTRAR WORKFLOW ÁRBOL*/
  public showSpecsTree = false;
  public itemsTree: Array<any> = [];
  public specsTree: Array<any> = [];

  /*BOTÓN BULK CHANGES*/
  public nuevo = {
    type: "iqid",
    value: "",
    value_two: "",
    change: 0,
  };
  public filterrigh = "";
  public small = true;
  public bulkErrors: boolean = false;
  public savingItem: boolean = false;
  public itemsNotFound;
  public itemsFound;
  public bulkItemID;

  public conditions: Array<any> = [];
  public bulkCondition;
  public bulkWarhouse;
  public bulkLocation;
  public bulkDescription;

  public wharehouseList: Array<any> = [];
  public buscandoWharehouse = true;
  public permissionStatus = false;

  public textNotFound = "";
  public textFound = "";

  public logs: Array<any> = [];
  public inventoryLogId;

  public cattype = [
    {value: 'pc', viewValue: 'Desktop'},
    {value: 'laptop', viewValue: 'Laptop'},
    {value: 'server', viewValue: 'Server'},
    {value: 'switch', viewValue: 'Switch'}
  ];

  public categoryType: string = '';

  public isCheckedAllPO: boolean = true; // Controla si el select se muestra u oculta
  //public poOptions: any[] = []; // Array de objetos que contiene los PO
  
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public poCtrl = new FormControl();
  public filteredPOs: Observable<PO[]>;
  public selectedPOs: PO[] = [];
  public poOptions: PO[] = []; // Inicialmente vacío, se llenará desde el servicio

  form = new FormGroup({
    poInput: new FormControl()
  });

  public loadingReport: boolean = false;

  /*public data: DinamicData = new DinamicData(
    ['check', 'Id', 'Mfgr', 'Item', 'Serial#', 'Container Id', 'Type', 'Testing Status', 'Added', 'Date Received', 'Condition', 'Qty', 'Warehouse', 'PO#', 'PO Rep', 'SO#', 'SO Rep', 'Status', 'Actions']
  )*/

  constructor(
    private titleService: Title,
    public dialog: MatDialog,
    private _router: Router,
    private _service: PrincipalinventoryService,
    private _mfgrService: ManuracturerService,
    private _route: ActivatedRoute,
    public guard: GuiGuard,
    private _config: ConfigService,
    private _userService: UserService,
    private _purchaseService: PurchaseService,
    private _locationService: LocationService,
    private _securazeService: SecurazeService,
    private _ticketsService: TicketsService,
    private mobilesdevicesService: MobilesdevicesService,
    private titleServices: TitleService
  ) {
    this.titleService.setTitle("Inventory");
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.apikey = this.identity.apiCompany;
    this.canCreate();
  }

  ngOnInit() {
    let me = this;
    this._config.getConfig("optimizedtableinventory2").subscribe(
      (r) => {
        console.log("tabladinamica => ", r);
        if (r.data) {
          this.tablaDinamicaSet = true;
          this.options = JSON.parse(r.data.data);
          this.itemsPorPagina = r.data.pageLimit;
        } else {
          this.tablaDinamicaSet = false;
          this.options = this.mtds.colopt(this.data.headers, []);
        }
        this.loadDataAsync();
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );
    this.getMfgrList();
    this.getPOS();

    this.filteredPOs = this.poCtrl.valueChanges.pipe(
      startWith(''),
      map((po: string | PO) =>
        po ? this._filter(po) : this.poOptions.slice()
      )
    );

    // this._route.params.subscribe(params => {
    //   if (params['id']) {
    //     const e = {
    //       action: 'Detail',
    //       id: params['id']
    //     };
    //     setTimeout(() => {
    //       this.action(e);
    //       history.pushState(null, "", "/principalinventory");
    //     }, 300);
    //   }
    // });
    $("#modalLogs").on("hide.bs.modal", function (e) {
      console.log("modal is closed");
    });
    this.titleServices.setTitle('Inventory');
  }

  canCreate() {
    try {
      let st: any = this.guard.permissions("attributeMultiple"); 
      if (st === undefined || st === null) {
        console.error('El valor de st es inválido: ', st);
        return;
      }
  
      if (typeof st === 'string') {
        try {
          if (st.trim() !== '' && st !== 'undefined') { 
            st = JSON.parse(st);
          } else {
            console.error('La cadena de st está vacía o no es JSON válido:', st);
            return;
          }
        } catch (jsonError) {
          console.error('Error al analizar JSON en permissions: ', jsonError);
          return;
        }
      }

      this.permissionStatus = !!st;
    
    } catch (e) {
      console.log('Error en canCreate: ', e);
    }
  }

  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._config.setConfig("optimizedtableinventory2", this.options).subscribe((r) => {
      console.log(r);
    });
  }

  getPOS(): void {
    this._ticketsService.getPOsNotInvoiced().subscribe((r) => {
      this.poOptions = r.data; // Guardar las opciones obtenidas desde el servicio
      // Actualizar las opciones filtradas
      console.log(this.poOptions.length);
      this.filteredPOs = this.poCtrl.valueChanges.pipe(
        startWith(''),
        map((po: string | PO) =>
          po ? this._filter(po) : this.poOptions.slice()
        )
      );
    });
  }

  /*  */
  private latestRequestId = 0;
  async loadDataAsync(params?: any): Promise<void> { 
    this.latestRequestId++;
    const currentRequestId = this.latestRequestId;
    this.loading = true;
    this.showDetails = false;
    try {
      const response = await lastValueFrom(
        this._service
        .showAllOpti(
          this.paginaActual,
            this.itemsPorPagina ,
        this.campoBusqueda,
        this.filterStatus,
        this.filterMfgr,
        this.type,
        "",
        "",
        this.filtros,
        this.filterrigh,this.sortStates
        )
      );
      if (currentRequestId !== this.latestRequestId) {
        console.log('Respuesta antigua ignorada');
        return;
      }
      this.data = this.transformResponseToDinamicData(response);
    } catch (error: any) {
      this.mtds.notifyError(error.statusText, error.status);
    } finally {
      if (currentRequestId === this.latestRequestId) {
        this.loading = false;
      }
    }
  }

  private transformResponseToDinamicData(r: any): DinamicData { 
    const headers = [...this.data.headers]; 
    let row = []
    let rows = [];
    if (r.status === "success") {
      this.paginaActual = Number(r.page_actual);
      this.itemsPorPagina = String(r.items_per_page);
      this.totalItems = Number(r.total_items_count);
      this.totalPaginas = Number(r.total_pages);

      const actionButtons = [
        { icon: "remove_red_eye", action: "Detail", color: "info" },
        { icon: "print", action: "Print", color: "primary" },
        // { icon: 'delete_outline', action: 'Remove', color: 'danger' }
      ];
      row = [];

      for (const element of r.data) {
        let selected_value = false;

        if (this.bulk.includes(element.id.toString()))
          selected_value = true;

        //this.arrayInventoryReceived.push(element);

        const resultado = this.arrayInventoryReceived.find(
          (obj) => obj.id === element.id
        );

        if (!resultado) this.arrayInventoryReceived.push(element);

        row = [
          new Cell(element.id, {
            type: "checkbox",
            selected: selected_value,
           
          }), // Check box
          new Cell(element.Item, {
            
          }), // Item
          new Cell(element.mfgr, {
            
          }), // Brand
          new Cell(element.serialnumber, {
          
          }), // Serial Number
          new Cell(element.typeitem), // Type
          new Cell(element.description, {
            style: 'width:50px!important; min-width:50px!important;' }),  // Description
          new Cell(element.conditioninventory), // Condition
          new Cell(`${element.poid}-${element.poline}`,{ class: "fw-bold", color: "primary" }), // PO - Line
          new Cell(element.quantity), // Quantity
          new Cell(element.purchasecost), // Cost
          new Cell(element.status, {
       
            class: "fw-bold",
            color: element.status === "Available" ? "green" : "orange",
          }), // Status
          new Cell(element.receivestatus, {
            class:
              "fw-bold" /* color: element.status === 'Available' ? 'green' : 'orange' */,
          }), // Receive Status
          //new Cell(element.so !== null ? `${element.so.so} - ${element.soLine}` : `${element.so2} - ${element.soLine}`, {class: 'fw-bold', color: 'success'}), // SO
          new Cell(
            element.so2 !== null
              ? `${element.so2} - ${element.soLine}`
              : `0 - 0`,
            { class: "fw-bold", color: "success" }
          ), // SO
          new Cell(
            element.sorep
            ? element.sorep
                .split(' ') 
                .map((word) => word[0]) 
                .join('') 
                .toUpperCase() 
            : "",
            {
              title:
                element.sorep !== null && element.sorep!
                  ? `${element.sorep}`
                  : "",
            }
          ), // SO Rep
          new Cell(
            element.WarehouseName !== null
              ? element.WarehouseName
              : null
          ), // Warehouse
          new Cell(
            element.porep
              ? element.porep
                  .split(' ') 
                  .map((word) => word[0]) 
                  .join('') 
                  .toUpperCase() 
              : "",
            {
              title:
                element.porep !== null && element.porep!
                  ? `${element.porep}`
                  : "",
            }
          ), // PO Rep
          new Cell(element.lastupdated, { type: "date" }), // Updated Date
          new Cell(element.customerAsset), // Customer Asset Tag
          new Cell(element.location, {
            style: 'width:130px!important; min-width:130px!important;' }),  // Location
          new Cell(element.batchid ? element.batchid : ""),
          new Cell(element.weightItemID ? element.weightItemID : ""),
          // Container id
          new Cell(element.nameVirtualContainer), // Virtual Container Name
          new Cell(this.mtds.capitalize(element.testingStatus)), // Testing Status
          new Cell(element.added, {
            style: 'width:50px!important; min-width:50px!important;' }), // Added Date
          new Cell(element.datereceived, {
            style: 'width:50px!important; min-width:50px!important;' }), // Date Received
          /* new Cell(element.location), // Location */
          new Cell(element.inventoryid || ""), // IQ ID
          new Cell(element.id), // ID
          new Cell(
            element.Vendorname !== null || element.Vendorname!  ? `${element.Vendorname}`
              : ""
          ), // PO Vendor
          new Cell(actionButtons, { type: "actions"  }),
        ];
        rows.push(row);
        let item = {
          id: element.id,
          categories: element.categories,
        };

        this.itemsTree.push(item);
      }
      console.log(this.arrayInventoryReceived);
    } else {
      this.mtds.notifyError(r.msg, r.code);
    }
    this.loading = false;
    return new DinamicData(headers, rows);
  }
  /*  */

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      const poFound = this.poOptions.find(option => option.po === +value);
      if (poFound && !this.selectedPOs.includes(poFound)) {
        this.selectedPOs.push(poFound);
      }
    }

    event.chipInput!.clear();
    this.poCtrl.setValue(null);
  }

  remove(po: PO): void {
    const index = this.selectedPOs.indexOf(po);

    if (index >= 0) {
      this.selectedPOs.splice(index, 1);
    }
  }

  selected(event: any): void {
    const selectedPO = event.option.value;
    if (!this.selectedPOs.includes(selectedPO)) {
      this.selectedPOs.push(selectedPO);
    }
    this.poCtrl.setValue(null);
  }

  private _filter(value: string | PO): PO[] {
    const filterValue = typeof value === 'string' ? value : value.po.toString();
    return this.poOptions.filter(option =>
      option.po.toString().includes(filterValue)
    );
  }
  uncheckedall(){
    this.bulk = [];
  }
  cancelReportsModal(){
    this.isCheckedAllPO = true;
    this.selectedPOs = [];
    $("#reportsModal").modal("hide");
  }

  public doingsync = false;

  generateReport(){

    const type = 'REPORTPOINVENTORY';

    const idsArray = this.selectedPOs.map(item => item.id);

    const po = this.isCheckedAllPO ? '1' : '0';

    const json = {
      apikey: this.apikey,
      data: idsArray,
      type: this.categoryType,
      po
    };

    this.doingsync = true;

    this._purchaseService.newsync(json, type).subscribe(
      e => {
        console.log(e);

        this.cancelReportsModal();

        swal.fire({
       
          title: e.status,
          text: e.msg,
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success'
          },

        });
        this.doingsync = false;
      }, error => {
        console.log(error);
        this.doingsync = false;
        swal.fire({
       
          title: 'ERROR!',
          text: 'Something went wrong',
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success'
          },

      });
      }
    );

    /*this._service.reportWithAttributesPO(json).subscribe(
      (response) => {
        //console.log(response);
        if (response._body) {
          let body = JSON.parse(response._body);
          this.mtds.notifyError(body.error);
        } else {
          const url = response.headers.get("Content-Disposition").split("=");
          window.open(url[1]);
        }
      },
      (error) => {
        console.log(error);
      }
    );*/


  }

  printLabels() {
    let labels = String(this.bulk).replace(/,/g, "-");

    window.open(
      "https://www.greenteksolutionsllc.com/backend/reports/print-inventory-item-bulk.php?idweight=" +
        labels +
        "&idweight_inventory=&apitoken=" +
        this.apikey +
        "&u=" +
        this.identity.sub
    );
  }

  recibirSeleccionados() {
    swal
      .fire({
        title: "Receive selected items?",
        text: "",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            this.recibiendo();
          }
        }.bind(this)
      );
  }

  /*SECCION BULK CHANGES*/

  cleanValues() {
    this.bulkErrors = false;
    this.nuevo.value = "";
    this.bulkLocation = null;
    this.bulkCondition = null;
    this.bulkWarhouse = null;
    this.bulkDescription = null;
  }

  cleanValuesCheck() {
    $("#modalConfirmBulkChanges").modal("hide");
    this.textFound = "";
    this.textNotFound = "";
  }

  changeBulk(evento) {
    console.log("evento => ", evento);
    if (evento && evento.cleanall) {
      this.bulk = [];
    }
  }

  openEpsPxe() {
    $("#epsmodal").modal("show");
  }

  bulkChanges() {
    this.itemsFound = [];
    this.itemsNotFound = [];
    this.bulkItemID = [];
    this.textFound = "";
    this.textNotFound = "";

    if (this.bulk.length === 0) $("#createModal").modal("show");
    else this.openBulkChanges();
  }

  getReports(){
    $("#reportsModal").modal("show");
  }
  buttonConfig = {
    name: 'Reports',
    class: 'gts-btn-primary pr-2',
    action: this.getReports.bind(this), 
  };
  buttonConfig2 = {
    name: 'Bulk Changes',
    class: 'gts-btn-primary',
    action: this.bulkChanges.bind(this), 
  };
  openBulkChanges() {
    this.getConditions();
    this.getLocations();
    this.cleanValues();

    $("#modalConfirmBulkChanges").modal("hide");
    $("#modalBulkChanges").modal("show");
  }

  Rescan() {
    this.nuevo.value = this.textFound + "\n" + this.textNotFound;

    this.itemsFound = [];
    this.itemsNotFound = [];
    this.bulkItemID = [];
    this.textFound = "";
    this.textNotFound = "";

    this.checkItems();
  }

  checkItems() {
    //$("#modalConfirmBulkChanges").modal("hide");
    $("#createModal").modal("hide");

    this.savingItem = true;
    this._service.bulkChangesCheck(this.nuevo).subscribe(
      (r) => {
        if (r.code === 200 && r.notfound.length > 0 && r.found.length > 0) {
          this.bulkErrors = true;
          this.itemsNotFound = r.notfound;
          this.itemsFound = r.found;
          this.bulkItemID = r.bulkItemID;

          for (const element of r.found) {
            if (this.textFound === "") this.textFound = element.id_inventory;
            else this.textFound = this.textFound + "\n" + element.id_inventory;
          }

          for (const element of r.notfound) {
            if (this.textNotFound === "")
              this.textNotFound = element.id_inventory;
            else
              this.textNotFound =
                this.textNotFound + "\n" + element.id_inventory;
          }

          this.cleanValues();
          $("#modalConfirmBulkChanges").modal("show");
        } else if (
          r.code === 200 &&
          r.found.length > 0 &&
          r.notfound.length === 0
        ) {
          this.itemsFound = r.found;
          this.itemsNotFound = r.notfound;
          this.bulkItemID = r.bulkItemID;
          this.openBulkChanges();
          this.cleanValues();
        } else if (
          r.code === 200 &&
          r.found.length === 0 &&
          r.notfound.length > 0
        ) {
          this.bulkErrors = true;
          this.itemsNotFound = r.notfound;
          this.itemsFound = r.found;
          this.bulkItemID = r.bulkItemID;

          for (const element of r.notfound) {
            if (this.textNotFound === "")
              this.textNotFound = element.id_inventory;
            else
              this.textNotFound =
                this.textNotFound + "\n" + element.id_inventory;
          }
          this.cleanValues();
          $("#modalConfirmBulkChanges").modal("show");
        } else {
          this.mtds.notifyError(r.msg);
        }
        this.savingItem = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.savingItem = false;
      }
    );
  }

  getConditions() {
    this._locationService.getConditions(this.token).subscribe((response) => {
      this.conditions = response.data;
    });
  }

  getLocations() {
    this._locationService
      .getLocationsByUser(this.token, this.identity.sub)
      .subscribe((response) => {
        console.log(response);
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.wharehouseList = response.data;
        } else {
          this.mtds.notifyError("ERROR!", response.msg);
        }
        this.buscandoWharehouse = false;
      });
  }

  changeWH(e) {
    this.bulkWarhouse = e.id;
  }

  saveBulkChanges() {
    let items;

    if (this.bulk.length > 0) items = this.bulk;
    else items = this.bulkItemID;

    let json = {
      items: items,
      condition: this.bulkCondition,
      warehouse: this.bulkWarhouse,
      location: this.bulkLocation,
      description: this.bulkDescription,
    };

    this.savingItem = true;
    this._service.saveBulkChanges(json).subscribe(
      (r) => {
        console.log(r);
        if (r.status === "success") {
          this.mtds.notifySuccess("Selected items have been changed");
        } else {
          this.mtds.notifyError(r.msg);
        }
        $("#modalBulkChanges").modal("hide");
        this.savingItem = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.savingItem = false;
      }
    );
  }

  /*TERMINA SECCIÓN BULK CHANGES*/

  recibiendo(recibir = 1) {
    var myArray = [];

    this.bulk.map((item) => {
      const resultado = this.arrayInventoryReceived.find(
        (obj) => obj.id === Number(item)
      );

      if (resultado) {
        if (resultado.receivestatus === "In Transit") {
          let json = {
            automatic_receive: 1,
            bulk: [Number(item)],
            idPoGroup: resultado.PoGroupId,
            poid: resultado.popoid,
          };

          myArray.push(json);
        }
      }
    });

    this._purchaseService.recivedMultyInventory(myArray).subscribe(
      (response) => {
        console.log(response);
        this.bulk = [];
        this.arrayInventoryReceived = [];
        if (response.code === 200) {
          this.loadDataAsync();
          this.mtds.notifySuccess("Selected items have been received");
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  undoRecive() {
    swal
      .fire({
        title: "Undo Receive selected items?",
        text: "",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            var myArray = [];

            this.bulk.map((item) => {
              const resultado = this.arrayInventoryReceived.find(
                (obj) => obj.id === Number(item)
              );

              if (resultado) {
                if (resultado.receivestatus === "Received") {
                  let json = {
                    poid: resultado.popoid,
                    bulk: [Number(item)],
                  };

                  myArray.push(json);
                }
              }
            });

            console.log(myArray);

            this._purchaseService.undorecivedMultyInventory(myArray).subscribe(
              (response) => {
                this.bulk = [];
                this.arrayInventoryReceived = [];
                if (response.code === 200) {
                  this.loadDataAsync();
                  this.mtds.notifySuccess(
                    "Selected items have been undo received"
                  );
                } else {
                  this.mtds.notifyError(response.msg, response.code);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
              }
            );
          }
        }.bind(this)
      );
  }

  procesar(action, mark) {
    let ids = String(this.bulk).replace(/,/g, "-");
    let changeMark;

    if (mark === 1) changeMark = "TESTED";
    else changeMark = "NOT TESTED";

    if (action === "test") {
      this._service.testBulkItem(ids, changeMark).subscribe(
        (response) => {
          if (response.status === "success") {
            this.bulk = [];
            this.cambiar(this.type);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }

    if (action === "container") {
      const dialogRef = this.dialog.open(BulkContainerInventoryComponent, {
        width: "60%",
        data: 1,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this._service.bulkContainer(ids, result).subscribe(
            (response) => {
              if (response.status === "success") {
                this.bulk = [];
                this.cambiar(this.type);
                this.mtds.notifySuccess(
                  "The containers have been assigned successfully."
                );
              }
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    }

    if (action === "virtual-container") {
      const dialogRef = this.dialog.open(
        BulkVirtualContainerInventoryComponent,
        {
          width: "60%",
          data: 1,
        }
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this._service.bulkVirtualContainer(ids, result).subscribe(
            (response) => {
              if (response.status === "success") {
                this.bulk = [];
                this.cambiar(this.type);
                this.mtds.notifySuccess(
                  "The virtual containers have been assigned successfully."
                );
              }
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    }
  }

  cambiar(type: string) {
    this.type = type;
    if (this.type === "inventoryhistory") {
      this.history();
    } else {
      this.loadDataAsync();
    }
  }

  history(e = null) {
    this.loading = true;
    this._service
      .getInventoryHistory(
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null ? (this.campoBusqueda = e.search) : (this.campoBusqueda = "")
      )
      .subscribe(
        (r) => {
          console.log(r);

          if (r.code === 400 && r.msg === "Authorization not valid") {
            // this.mtds.notifyError('Your session has expired');
            // localStorage.clear();
            // this._router.navigate(['/pages/lock']);
          } else if (r.status === "success") {
            this.paginaActual = Number(r.page_actual);
            this.itemsPorPagina = String(r.items_per_page);
            this.totalItems = Number(r.total_items_count);
            this.totalPaginas = Number(r.total_pages);

            this.data.rows = [];

            this.data.headers = [
              //'check',
              "Id",
              "Rep",
              "Log",
              "Type",
              "Date",
            ];

            for (const element of r.data) {
              let selected_value = false;

              if (this.bulk.includes(element.id.toString()))
                selected_value = true;

              this.data.rows.push([
                new Cell(element.id),

                new Cell(
                  element.rep
                    ? `${element.rep.name} ${element.rep.surname}`
                    : ""
                ),
                new Cell(element.comment),
                new Cell(element.type),
                new Cell(element.createdAt, { type: "full-date" }),
              ]);
            }
          } else {
            this.mtds.notifyError(r.msg, r.code);
          }

          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
  }

  getMfgrList() {
    this._mfgrService.showAllLite().subscribe((r) => {
      this.mfgrList = r.data;
      this.loadingMFGR = false;
    });
  }

  byMfgr(e) {
    this.filterMfgr = e.id !== null ? e.name : "";
    this.loadDataAsync();
  }

  byStatus(e) {
    this.filterStatus = e;
    this.loadDataAsync();
  }

  action(e) {
    console.log(e, "myactionnn");

    switch (e.action) {
      case "Detail":
        // this._router.navigate(['/inventory', 'product', e.id]);
        window.open("/inventory/product/" + e.id);
        // const dialogRef = this.dialog.open(CrudInventoryComponent, {
        //   width: '40%',
        //   data: {id:e.id, type: 'Inventory'},
        // });

        // dialogRef.afterClosed().subscribe( (result) => {
        //   if (result) {
        //     this.getData();
        //   }
        // });
        break;
      case "Print":
        window.open(
          "https://www.greenteksolutionsllc.com/backend/reports/print-inventory-item-bulk.php?idweight=" +
            e.id +
            "&idweight_inventory=&apitoken=" +
            this.apikey +
            "&u=" +
            this.identity.sub
        );
        break;
      case "Attribute":
        this.showDetails = true;
        this.showSpecs = false;
        this.showSpecsWorkflow = false;
        this.showSpecsTree = false;

        this.showBothSpecs = false;

        this.batteries = [];
        this.components = [];
        this.cpus = [];
        this.hdds = [];
        this.memories = [];
        this.networks = [];
        this.system = [];
        this.testing = [];
        this.video = [];

        this.internalComments = "";
        this.systemComments = "";

        this.workflow = [];

        this._service.getAttributes(e.id, "inventory").subscribe(
          (response) => {
            console.log(response);
            if (response.status === "success") {
              if (response.data.testing) {
                this.mdm = response.data.testing[0].mdm;
                this.computrace = response.data.testing[0].computrace;
              }

              this.batteries = response.data.batteries;
              this.components = response.data.components;
              this.cpus = response.data.cpus;
              this.hdds = response.data.hdds;
              this.memories = response.data.memories;
              this.networks = response.data.networks;
              this.system = response.data.system;
              this.testing[0] = response.data.testing[0];
              this.video = response.data.video;
              this.poline = response.data.inventory.poline;
              this.batchline = response.data.batchNumber;

              this.internalComments = response.data.inventory.internalComments;
              this.systemComments = response.data.inventory.systemcomments;

              this.showSpecs = true;

              if (this.showSpecs && this.showSpecsTree) {
                this.showBothSpecs = true;
                this.showSpecs = false;
                this.showSpecsTree = false;
              }
            } else {
              this.internalComments = response.data.internalComments;
              this.systemComments = response.data.systemcomments;
            }
          },
          (error) => {
            //this.mtds.notifyError('Inventory not found!');
            console.log("Error");
          }
        );

        const json = {
          apikey: this.apikey,
          data: e.id,
        };

        this._service.getWorkflow(json).subscribe(
          (response) => {
            if (response._body) {
              let body = JSON.parse(response._body);

              if (body.length > 0) {
                this.workflow = body;
                this.showSpecsWorkflow = true;
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );

        /*MOSTRAR SPECS DEL ÁRBOL SI ES QUE TIENE*/
        // const resultado = this.itemsTree.find((obj) => obj.id === e.id);

        // if (resultado.categories !== null) {
        //   this._securazeService.getSpecsTree(this.token, e.id).subscribe(
        //     (response) => {
        //       this.showSpecsTree = true;
        //       this.specsTree = response.data;
        //       console.log(this.specsTree);
        //     },
        //     (error) => {
        //       console.log(error);
        //     }
        //   );
        // }

        break;
      case "showLogs":
        this.getdatabitraser(e)
        this.getdataphonecheck(e)
        this.showSpecsTree = false;
        this.selectedTabIndex = 2;

        this.getLogs(e.id);
        const resu = this.itemsTree.find((obj) => obj.id === e.id);

        if (resu.categories !== null) {
          this._securazeService.getSpecsTree(this.token, e.id).subscribe(
            (response) => {
              if(response.data.children.length === 0){
                this.showSpecsTree = false;
              }else{
                this.showSpecsTree = true;
                this.selectedTabIndex = 0;
  
                this.specsTree = response.data;
                console.log(this.specsTree, "specstree");
              }

            },
            (error) => {
              console.log(error);
            }
          );
        }
        this.showDetails = true;
        this.showSpecs = false;

        // this.showBothSpecs = false;

        this.batteries = [];
        this.components = [];
        this.cpus = [];
        this.hdds = [];
        this.memories = [];
        this.networks = [];
        this.system = [];
        this.testing = [];
        this.video = [];

        this.internalComments = "";
        this.systemComments = "";

        this.workflow = [];

        this._service.getAttributes(e.id, "inventory").subscribe(
          (response) => {
            console.log(response);
            if (response.status === "success") {
              if (response.data.testing) {
                this.mdm = response.data.testing[0].mdm;
                this.computrace = response.data.testing[0].computrace;
              }

              this.batteries = response.data.batteries;
              this.components = response.data.components;
              this.cpus = response.data.cpus;
              this.hdds = response.data.hdds;
              this.memories = response.data.memories;
              this.networks = response.data.networks;
              this.system = response.data.system;
              this.testing[0] = response.data.testing[0];
              this.video = response.data.video;
              this.poline = response.data.inventory.poline;
              this.batchline = response.data.batchNumber;

              this.internalComments = response.data.inventory.internalComments;
              this.systemComments = response.data.inventory.systemcomments;

              this.showSpecs = true;

              // if (this.showSpecs && this.showSpecsTree) {
              //   this.showBothSpecs = true;
              //   this.showSpecs = false;
              //   this.showSpecsTree = false;
              // }
            } else {
              this.internalComments = response.data.internalComments;
              this.systemComments = response.data.systemcomments;
            }
          },
          (error) => {
            //this.mtds.notifyError('Inventory not found!');
            console.log("Error");
          }
        );

        break;
      default:
        break;
    }
  }
  getdatabitraser(id){
          this.raserhardware = null
          this.raserbatery = null
          this.raserdisk = null
          this.raservideo = null
          this.raserhardwaretest = null
          this.rasermemory = null
          this.rasernetwork = null
          this.raserprocessor = null
    this._securazeService.gedatabitraser(this.token, id.optionalValue).subscribe(
      (response) => {
        if(response.status === "success"){
          this.bitrasershow = true
          this.raserhardware = response.data.hardwareInfo;
          this.raserbatery = response.data.batteryInfo;
          this.raserdisk = response.data.diskInfo;
          this.raservideo = response.data.graphisInfo;
          this.raserhardwaretest = response.data.hardwareTest;
          this.rasermemory = response.data.memoryInfo;
          this.rasernetwork = response.data.networkInfo;
          this.raserprocessor = response.data.proccessorInfo;
        }else{
          this.bitrasershow = false
        }

      },
      (error) => {
        this.phonecheckshow = false
        console.log(error);
      }
    );
  }
getdataphonecheck(id){
  this.phonecheckinfo = null;
  this.phonecheckpart = null;
   this.phonecheckshow = false;
 /*  let testid="K9QH4CMV71" */
  this.mobilesdevicesService.Getphonecheckdata(id.optionalValue).subscribe(
    response => {
      if(response.status === "success"){
        this.phonecheckshow = true
        this.phonecheckinfo = response.result;
        this.phonecheckpart = response.Parts.Data;
      }else{
        this.phonecheckshow = false
      }

    },
    error => {
      this.phonecheckshow = false
      console.error('Error:', error);
    }
  );

}
  public showSystemComments = false;

  getLogs(id) {
    this.showSystemComments = false;

    this.inventoryLogId = id;

    this._service.getLogs(id, "").subscribe((r) => {
      console.log(r);
      if (r.status === "success") {
        this.systemComments = "";
        this.logs = r.data;
        this.systemComments = r.systemComments;

        $("#modalLogs").modal("show");
        if (this.logs && !this.showSpecsTree) {
          this.selectedTabIndex = 1;
        } else if (this.logs && !this.showSpecsTree && this.showSpecs) {
          this.selectedTabIndex = 2;
        }
      }
    });
  }

  showSpecsFunction(param) {
    if (param === "TREE") {
      this.showSpecsTree = true;
      this.showSpecs = false;
    } else if (param === "EPS") {
      this.showSpecs = true;
      this.showSpecsTree = false;
    }
  }

  public filtros = [
    null, // Checkbox
    {
      key: "item",
      title: "Item",
      value: "",
      type: "contains",
      key_type: "item_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "mfgr",
      title: "Brand",
      value: "",
      type: "contains",
      key_type: "mfgr_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "serialnumber",
      title: "SN",
      value: "",
      type: "contains",
      key_type: "serialnumber_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "type",
      title: "Category",
      value: "",
      type: "contains",
      key_type: "type_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "description",
      title: "Description",
      value: "",
      type: "contains",
      key_type: "description_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "condition",
      title: "Condition",
      value: "",
      type: "contains",
      key_type: "condition_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "po_line",
      title: "PO-Line",
      value: "",
      type: "equalto",
      key_type: "po_line_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "quantity",
      title: "QTY",
      value: "",
      type: "startswith",
      key_type: "quantity_type",
      type_options: [{ value: "startswith", name: "Starts With" }],
    },
    {
      key: "cost",
      title: "Cost",
      value: "",
      type: "startswith",
      key_type: "cost_type",
      type_options: [{ value: "startswith", name: "Starts With" }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' } , { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }],
    },
    {
      key: "status",
      title: "Status",
      value: "",
      type: "contains",
      key_type: "status_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "receivestatus",
      title: "Receive Status",
      value: "",
      type: "contains",
      key_type: "receivestatus_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "so",
      title: "SO - Line",
      value: "",
      type: "contains",
      key_type: "so_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "so_rep",
      title: "SO REP",
      value: "",
      type: "contains",
      key_type: "so_rep_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "warehouse",
      title: "Warehouse",
      value: "",
      type: "contains",
      key_type: "warehouse_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "po_rep",
      title: "PO REP",
      value: "",
      type: "contains",
      key_type: "po_rep_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "update_date",
      title: "Update Date",
      value: "",
      type: "contains",
      key_type: "update_date_type",
      type_options: [{ value: "startswith", name: "Starts With" }],
    },
    {
      key: "customerassettag",
      title: "Customer Asset Tag",
      value: "",
      type: "contains",
      key_type: "customerassettag_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "location",
      title: "Location",
      value: "",
      type: "contains",
      key_type: "location_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "batch_id",
      title: "Batch ID",
      value: "",
      type: "contains",
      key_type: "batch_id_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "container_id",
      title: "Container ID",
      value: "",
      type: "contains",
      key_type: "container_id_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "id_virtual_container",
      title: "Virtual Container",
      value: "",
      type: "contains",
      key_type: "id_virtual_container_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "testing_status",
      title: "Testing Status",
      value: "",
      type: "equalto",
      key_type: "testing_status_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "added",
      title: "Added",
      value: "",
      type: "startswith",
      key_type: "added_type",
      type_options: [{ value: "startswith", name: "Starts With" }],
    },
    {
      key: "received",
      title: "Date Received",
      value: "",
      type: "startswith",
      key_type: "received_type",
      type_options: [{ value: "startswith", name: "Starts With" }],
    },
    {
      key: "iq_id",
      title: "IQ ID",
      value: "",
      type: "contains",
      key_type: "iq_id_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    // { key: 'location', title: 'Location', value: '', type: 'contains', key_type: 'location_type', type_options: [
    //   { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    // ] },
    {
      key: "id",
      title: "ID",
      value: "",
      type: "contains",
      key_type: "id_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "vendor",
      title: "Vendor",
      value: "",
      type: "contains",
      key_type: "vendor_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
  ];

  getData(e = null) {
    let json = { status_default: [this.filterrigh] };
    this.loading = true;
    this.showDetails = false;
    console.log(e);
    this._service
      .showAllOpti(
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null
          ? (this.campoBusqueda = e.search)
          : (this.campoBusqueda = ""),
        this.filterStatus,
        this.filterMfgr,
        this.type,
        "",
        "",
        this.filtros,
        this.filterrigh,this.sortStates
      )
      .subscribe(
        (r) => {
          console.log(r);
          if (r.code === 400 && r.msg === "Authorization not valid") {
            // this.mtds.notifyError('Your session has expired');
            // localStorage.clear();
            // this._router.navigate(['/pages/lock']);
          } else if (r.status === "success") {
            this.paginaActual = Number(r.page_actual);
            this.itemsPorPagina = String(r.items_per_page);
            this.totalItems = Number(r.total_items_count);
            this.totalPaginas = Number(r.total_pages);

            const actionButtons = [
              { icon: "remove_red_eye", action: "Detail", color: "info" },
              { icon: "print", action: "Print", color: "primary" },
              // { icon: 'delete_outline', action: 'Remove', color: 'danger' }
            ];
            this.data.rows = [];

            for (const element of r.data) {
              let selected_value = false;

              if (this.bulk.includes(element.id.toString()))
                selected_value = true;

              //this.arrayInventoryReceived.push(element);

              const resultado = this.arrayInventoryReceived.find(
                (obj) => obj.id === element.id
              );

              if (!resultado) this.arrayInventoryReceived.push(element);

              this.data.rows.push([
                new Cell(element.id, {
                  type: "checkbox",
                  selected: selected_value,
    
                }), // Check box
                new Cell(element.Item, {
                 
                }), // Item
                new Cell(element.mfgr, {
                  
                }), // Brand
                new Cell(element.serialnumber, {
                 
                }), // Serial Number
                new Cell(element.typeitem), // Type
                new Cell(element.description, {
                  style: 'width:50px!important; min-width:50px!important;' }),  // Description
                new Cell(element.conditioninventory), // Condition
                new Cell(`${element.poid}-${element.poline}`,{ class: "fw-bold", color: "primary" }), // PO - Line
                new Cell(element.quantity), // Quantity
                new Cell(element.purchasecost), // Cost
                new Cell(element.status, {
                 
                  class: "fw-bold",
                  color: element.status === "Available" ? "green" : "orange",
                }), // Status
                new Cell(element.receivestatus, {
                  class:
                    "fw-bold" /* color: element.status === 'Available' ? 'green' : 'orange' */,
                }), // Receive Status
                //new Cell(element.so !== null ? `${element.so.so} - ${element.soLine}` : `${element.so2} - ${element.soLine}`, {class: 'fw-bold', color: 'success'}), // SO
                new Cell(
                  element.sono !== null
                    ? `${element.sono} - ${element.soLine}`
                    : `0 - 0`,
                  { class: "fw-bold", color: "success" }
                ), // SO
                new Cell(
                  element.sorep
                  ? element.sorep
                      .split(' ') 
                      .map((word) => word[0]) 
                      .join('') 
                      .toUpperCase() 
                  : "",
                  {
                    title:
                      element.sorep !== null && element.sorep!
                        ? `${element.sorep}`
                        : "",
                  }
                ), // SO Rep
                new Cell(
                  element.WarehouseName !== null
                    ? element.WarehouseName
                    : null
                ), // Warehouse
                new Cell(
                  element.porep
                    ? element.porep
                        .split(' ') 
                        .map((word) => word[0]) 
                        .join('') 
                        .toUpperCase() 
                    : "",
                  {
                    title:
                      element.porep !== null && element.porep!
                        ? `${element.porep}`
                        : "",
                  }
                ), // PO Rep
                new Cell(element.lastupdated, { type: "date" }), // Updated Date
                new Cell(element.customerAsset), // Customer Asset Tag
                new Cell(element.location, {
                  style: 'width:130px!important; min-width:130px!important;' }),  // Location
                new Cell(element.batchid ? element.batchid : ""),
                new Cell(element.weightItemID ? element.weightItemID : ""),
                // Container id
                new Cell(element.nameVirtualContainer), // Virtual Container Name
                new Cell(this.mtds.capitalize(element.testingStatus)), // Testing Status
                new Cell(element.added, {
                  style: 'width:50px!important; min-width:50px!important;' }),  // Added Date
                new Cell(element.datereceived, {
                  style: 'width:50px!important; min-width:50px!important;' }), // Date Received
                /* new Cell(element.location), // Location */
                new Cell(element.inventoryid || ""), // IQ ID
                new Cell(element.id), // ID
                new Cell(
                  element.Vendorname !== null || element.Vendorname!  ? `${element.Vendorname}`
                    : ""
                ), // PO Vendor
                new Cell(actionButtons, { type: "actions"  }),
              ]);

              let item = {
                id: element.id,
                categories: element.categories,
              };

              this.itemsTree.push(item);
            }
            console.log(this.arrayInventoryReceived);
          } else {
            this.mtds.notifyError(r.msg, r.code);
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
  }
  public sortStates = ""; 
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;
    this.loadDataAsync();
  }

  attributeMultipleItems() {
    let dialogRef = this.dialog.open(attributeMultipleItemsComponent, {
      width: "90%",
      data: this.bulk,
      disableClose: true,
      autoFocus: false,
      maxHeight: "90vh", //you can adjust the value as per your view
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loadDataAsync();
    });
  }

  reportWithAttributes(type) {
    const json = {
      apikey: this.apikey,
      data: this.bulk,
      type: type
    };
    const dialogRef = this.dialog.open(LoadingComponent, { width: "30%" });
    this._service.reportWithAttributes(json).subscribe(
      (response) => {
        //console.log(response);
        if (response._body) {
          let body = JSON.parse(response._body);
          this.mtds.notifyError(body.error);
          dialogRef.close();
        } else {
          dialogRef.close();
          const url = response.headers.get("Content-Disposition").split("=");
          window.open(url[1]);
        }
      },
      (error) => {
        console.log(error);
        dialogRef.close();
      }
    );
  }

  reportWithAttributesExtreme() {
    const json = {
      apikey: this.apikey,
      data: this.bulk,
    };

    const dialogRef = this.dialog.open(LoadingComponent, { width: "30%" });

    this._service.reportWithAttributesExtreme(json).subscribe(
      (response) => {
        //console.log(response);
        if (response._body) {
          let body = JSON.parse(response._body);
          this.mtds.notifyError(body.error);
          dialogRef.close();
        } else {
          dialogRef.close();
          const url = response.headers.get("Content-Disposition").split("=");
          window.open(url[1]);
        }
      },
      (error) => {
        console.log(error);
        dialogRef.close();
      }
    );
  }

  reportWithAttributesExtremeLaptop() {
    const json = {
      apikey: this.apikey,
      data: this.bulk,
    };
    const dialogRef = this.dialog.open(LoadingComponent, { width: "30%" });
    this._service.reportWithAttributesExtremeLaptop(json).subscribe(
      (response) => {
        //console.log(response);
        if (response._body) {
          dialogRef.close();
          let body = JSON.parse(response._body);
          this.mtds.notifyError(body.error);
        } else {
          dialogRef.close();
          const url = response.headers.get("Content-Disposition").split("=");
          window.open(url[1]);
        }
      },
      (error) => {
        console.log(error);
        dialogRef.close();
      }
    );
  }

  stopPropagation(event: WheelEvent): void {
    // Prevent the scroll event from bubbling up to the parent element
    event.stopPropagation();

    //console.log(event);

    // Perform any other scrolling logic you need here
    // For example, you can manually adjust the child's scrollTop property.
    //this.childScrollElement.nativeElement.scrollTop += event.deltaY;
  }

  ngAfterViewInit() {
    
    $("#inventoryTable").on("click", "tr", function (e) {
      console.log(e);
      let res = e.target.id.split("-");
      console.log(res);
      //me.saveEmit(res[1], res[0], res[2])
    });

    /*console.log("hola1");

    $(document).ready(function () {

      console.log("hola2");
      //var table = $('#example').DataTable();
   
      $('#inventoryTable').on('click', 'tr', function (e) {
        console.log("hola3");
          console.log(e);*/
    /*if ($(this).hasClass('selected')) {
              $(this).removeClass('selected');
          } else {
              table.$('tr.selected').removeClass('selected');
              $(this).addClass('selected');
          }*/
    //});

    /*$('#button').click(function () {
          table.row('.selected').remove().draw(false);
      });*/
    //});

    /*$('#inventoryTable').DataTable({


    });

    let me = this;
    const table =  $('#inventoryTable').DataTable();

    table.on('click', '.accion', function(e) {
        console.log(e);
        let res = e.target.id.split("-");
        console.log(res)
        //me.saveEmit(res[1], res[0], res[2])
    });*/
  }
}
